import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ButtonState, ButtonsState } from "./types";

const initialState: ButtonsState = {
  buttons: [],
  isLoading: false,
  error: null,
};

const buttonsSlice = createSlice({
  name: "buttons",
  initialState,
  reducers: {
    setButtons: (state, action: PayloadAction<ButtonState[]>) => {
      state.buttons = action.payload;
    },
    updateButton: (
      state,
      action: PayloadAction<{ id: string; updates: Partial<ButtonState> }>
    ) => {
      const { id, updates } = action.payload;
      const buttonIndex = state.buttons.findIndex((button) => button.id === id);
      if (buttonIndex !== -1) {
        state.buttons[buttonIndex] = {
          ...state.buttons[buttonIndex],
          ...updates,
        };
      }
    },
    toggleButtonAvailability: (state, action: PayloadAction<string>) => {
      const buttonId = action.payload;
      const button = state.buttons.find((btn) => btn.id === buttonId);
      if (button) {
        button.available = !button.available;
        button.isBlocked = !button.available;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setButtons,
  updateButton,
  toggleButtonAvailability,
  setLoading,
  setError,
} = buttonsSlice.actions;

export default buttonsSlice.reducer;
